export default __webpack_public_path__ + "static/waxzam-d5c452dad6d9d066a44be943f5545f06.png";